<div class="modal-header">
  <h5 class="modal-title">Informações Adicionais</h5>
</div>

<div class="modal-body">
  <div [formGroup]="form">
    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label for="affiliation">Instituição *</label>
          <div class="input-group mb-3">
            <input #questInput type="text" class="form-control" formControlName="affiliation"
              [ngClass]="{ 'is-invalid': submitted && form.get('affiliation').hasError('required') }"
              aria-describedby="basic-addon2" placeholder="Digite o nome da instituição">
            <!-- <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" (click)="questIES(questInput.value)">
                <i class="fa fa-search" aria-hidden="true" *ngIf="!loading"></i>
                <span class="align-center" *ngIf="loading">Carregando...</span>
              </button>
            </div> -->
            <small class="invalid-feedback" *ngIf="form.get('affiliation').hasError('required')">
              Instituição não foi informada
            </small>
          </div>
          <div class="list-group" *ngFor="let ie of ies">
            <button type="button" class="btn-link list-group-item" (click)="choiceIES(ie)">{{ ie.ies }}</button>
          </div>
        </div>
      </div>
    </div>


    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label>UF</label>
          <select #ufInput formControlName="uf" class="form-control"
            (change)="choiceUF(ufInput.value, cityInputDefaultOption)"
            [ngClass]="{ 'is-invalid': submitted && form.get('uf').hasError('required') }">
            <option title="Selecione..." value="" label="Selecione..." selected="selected" disabled>Selecione...
            </option>
            <option title="Acre" value="AC" label="Acre">Acre</option>
            <option title="Alagoas" value="AL" label="Alagoas">Alagoas</option>
            <option title="Amazonas" value="AM" label="Amazonas">Amazonas</option>
            <option title="Amapá" value="AP" label="Amapá">Amapá</option>
            <option title="Bahia" value="BA" label="Bahia">Bahia</option>
            <option title="Ceará" value="CE" label="Ceará">Ceará</option>
            <option title="Distrito Federal" value="DF" label="Distrito Federal">Distrito Federal</option>
            <option title="Espírito Santo" value="ES" label="Espírito Santo">Espírito Santo</option>
            <option title="Goiás" value="GO" label="Goiás">Goiás</option>
            <option title="Maranhão" value="MA" label="Maranhão">Maranhão</option>
            <option title="Minas Gerais" value="MG" label="Minas Gerais">Minas Gerais</option>
            <option title="Mato Grosso do Sul" value="MS" label="Mato Grosso do Sul">Mato Grosso do Sul</option>
            <option title="Mato Grosso" value="MT" label="Mato Grosso">Mato Grosso</option>
            <option title="Pará" value="PA" label="Pará">Pará</option>
            <option title="Paraíba" value="PB" label="Paraíba">Paraíba</option>
            <option title="Pernambuco" value="PE" label="Pernambuco">Pernambuco</option>
            <option title="Piauí" value="PI" label="Piauí">Piauí</option>
            <option title="Paraná" value="PR" label="Paraná">Paraná</option>
            <option title="Rio de Janeiro" value="RJ" label="Rio de Janeiro">Rio de Janeiro</option>
            <option title="Rio Grande do Norte" value="RN" label="Rio Grande do Norte">Rio Grande do Norte</option>
            <option title="Rondônia" value="RO" label="Rondônia">Rondônia</option>
            <option title="Roraima" value="RR" label="Roraima">Roraima</option>
            <option title="Rio Grande do Sul" value="RS" label="Rio Grande do Sul">Rio Grande do Sul</option>
            <option title="Santa Catarina" value="SC" label="Santa Catarina">Santa Catarina</option>
            <option title="Sergipe" value="SE" label="Sergipe">Sergipe</option>
            <option title="São Paulo" value="SP" label="São Paulo">São Paulo</option>
            <option title="Tocantins" value="TO" label="Tocantins">Tocantins</option>
          </select>
          <small class="invalid-feedback" *ngIf="form.get('uf').hasError('required')">
            Estado não foi informado
          </small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label>Cidade</label>
          <select formControlName="city_cod" class="form-control"
            [ngClass]="{ 'is-invalid': submitted && form.get('city_cod').hasError('required') }">
            <option #cityInputDefaultOption title="Selecione..." value="" label="Selecione..." selected="selected"
              disabled>Selecione...</option>
            <option *ngFor="let city of cities" value="{{ city.co_municipio }}">{{ city.ds_municipio }}</option>
          </select>
          <small class="invalid-feedback" *ngIf="form.get('city_cod').hasError('required')">
            Cidade não foi informada
          </small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label>País</label>
          <select formControlName="country" class="form-control"
            [ngClass]="{ 'is-invalid': submitted && form.get('country').hasError('required') }">
            <option *ngFor="let country of countries" value="{{ country.code }}">{{ country.name }}</option>
          </select>
          <small class="invalid-feedback" *ngIf="form.get('country').hasError('required')">
            País não foi informado
          </small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label>Área de Conhecimento</label>
          <select #knowledgementAreaInput class="form-control"
            (change)="questKnowledgementSubareas(knowledgementAreaInput.value, knowledgementAreaInputDefaultOption)">
            <option title="Selecione..." value="" label="Selecione..." selected="selected" disabled>Selecione...
            </option>
            <option *ngFor="let knowledgement_area of knowledgement_areas" value="{{ knowledgement_area.name }}">
              {{ knowledgement_area.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col">
        <div class="form-group">
          <label>Subárea</label>
          <select #knowledgementSubareaInput formControlName="knowledgement_area" class="form-control"
            [ngClass]="{ 'is-invalid': submitted && form.get('knowledgement_area').hasError('required') }">
            <option #knowledgementAreaInputDefaultOption title="Selecione..." value="" label="Selecione..."
              selected="selected" disabled>Selecione...</option>
            <option *ngFor="let knowledgement_area of knowledgement_subareas" value="{{ knowledgement_area.name }}">
              {{ knowledgement_area.name }}
            </option>
          </select>
          <small class="invalid-feedback" *ngIf="form.get('knowledgement_area').hasError('required')">
            Subárea não foi informada
          </small>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button *ngIf="!institutionData" type="button" class="btn btn-link mainFontColor" (click)="logout()">Sair</button>
  <button *ngIf="institutionData" type="button" class="btn btn-link mainFontColor"
    (click)="activeModal.close()">Voltar</button>
  <button type="button" (click)="save()" [attr.data-loader]="!submitted" btnloader
    class="btn btn-primary mainBackground-color">
    Salvar
  </button>
</div>